const config = {
    // GoogleMaps API key for address to LatLng conversion
    GOOGLE_MAPS_API_KEY: 'AIzaSyD5CnnNz1Hh7r8P6oInNYO5G6aJFRRww4Q',
    // Note: There should not be trailing / and the end
    API_URL: 'https://backend.provider.uk.mazingday.com',
    // API_URL: 'http://localhost:3000',
    // hideRegisterPage, removes registerPage from UI [ make sure to disable endpoint in backend also ]
    HIDE_REGISTER_PAGE: false,
};
export default config;
